module.exports = __webpack_public_path__ + "img/tanand-logo.0f4618ee.png";